export default {
  error: "Oops! Something went wrong. Please try again.",
  loading: "Loading...",
  logOut: "Log out",
  accessDeniedToast: "You do not have the necessary access to view this page",
  accessDeniedMessage:
    "It looks like you don't have the correct access to view this page. Please contact your account owner to request access.",
} as const;
